import { ThirdPartyAppCredentialsPopupDetails } from '@coach-bot/data-access/shared/interfaces';
import { CURRENT_LANGUAGE_LOCAL_STORAGE_KEY } from '@shared/translate/constants';
import { Language } from '@shared/translate/enums';
import { getRawTranslation } from '@shared/translate/utils/get-raw-translation';
import { getLocalStorage } from './local-storage';
import { Services } from '../services';

export async function getThirdPartyAppCredentialsPopupDetails(
  appName: string,
  forAutoLogin: boolean,
  services: Services,
): Promise<ThirdPartyAppCredentialsPopupDetails> {
  const assetsPath: string = chrome.runtime.getURL('assets');
  const language: Language | undefined = await getLocalStorage<Language>(CURRENT_LANGUAGE_LOCAL_STORAGE_KEY);
  return {
    logoSrc: `${assetsPath}/${services.coachBotViewStore.extensionIcon$.value}`,
    closeIconSrc: `${assetsPath}/icons/x-icon.svg`,
    description: await getRawTranslation(
      'student.third_party_app_credentials.labels.' + (forAutoLogin ? 'description_auto_login' : 'description_view'),
      language,
      {
        app: appName,
      }
    ),
    usernameLabel: await getRawTranslation('student.third_party_app_credentials.labels.username', language),
    passwordLabel: await getRawTranslation('student.third_party_app_credentials.labels.password', language),
  };
}
